import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HeaderComponent} from '../../layouts/header/header.component';
import {FooterComponent} from '../../layouts/footer/footer.component';
import {MenuMobileComponent} from '../../layouts/menu-mobile/menu-mobile.component';
import {MenuMobileUserComponent} from '../../layouts/menu-mobile-user/menu-mobile-user.component';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {HeaderMobileComponent} from '../../layouts/header-mobile/header-mobile.component';
import {DirectivesModule} from '../../directives/directives.module';
import {PromoBarComponent} from '../../layouts/promo-bar/promo-bar.component';
import {TrustpilotWidgetModule} from '../../shared/trustpilot-widget/trustpilot-widget.component';
import {NotificationsListComponent} from '../../notifications/notifications-list/notifications-list.component';
import {PipesModule} from '../../pipes/pipes.module';
import {GoogleAnalyticsModule} from '../tracking/google-analytics.module';
import {FacebookPixelModule} from '../tracking/facebook-pixel.module';


@NgModule({
    declarations: [
        HeaderComponent,
        FooterComponent,
        MenuMobileComponent,
        MenuMobileUserComponent,
        HeaderMobileComponent,
        PromoBarComponent,
        NotificationsListComponent
    ],
    exports: [
        HeaderComponent,
        HeaderMobileComponent,
        FooterComponent,
        MenuMobileComponent,
        MenuMobileUserComponent,
        NotificationsListComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        AngularSvgIconModule,
        RouterModule,
        DirectivesModule,
        TrustpilotWidgetModule,
        PipesModule,
        GoogleAnalyticsModule,
        FacebookPixelModule,
    ]
})
export class DefaultSiteSectionsModule {
}
